<div
  class="fc-search-input"
  [ngClass]="{ 'legacy-style': legacyStyle }"
  [class.disabled]="control.disabled"
  [class.invalid]="(control.touched || searchTerm.touched) && control.errors"
  matAutocompleteOrigin
  #origin="matAutocompleteOrigin"
>
  <div class="fc-search-input__prefix" (click)="input.focus()" *ngIf="showSearchIcon">
    <mat-icon>search</mat-icon>
  </div>
  <div class="fc-search-input__infix" [class.float-label]="control.value" [class.search-icon-hidden]="!showSearchIcon">
    <label
      class="fc-search-input__infix-label"
      [class.fc-search-input__infix-label--error]="(control.touched || searchTerm.touched) && control.errors"
      >{{ label }}<span *ngIf="requiredMark">*</span></label
    >
    <input
      class="fc-search-input__infix-input"
      #input
      [formControl]="searchTerm"
      [matAutocomplete]="matAutocomplete"
      [matAutocompleteConnectedTo]="origin"
      [hidden]="control.value"
      (focus)="onFocus()"
    />
    <input
      class="fc-search-input__infix-input filled"
      [class.disabled]="control.disabled"
      *ngIf="control.value"
      [value]="displayText"
      disabled
    />
    <small
      class="fc-search-input__infix-error"
      [class.fc-search-input__infix-error--with-search-icon-hidden]="!showSearchIcon"
      *ngIf="(control.touched || searchTerm.touched) && control.errors && !isDuplicatedForm"
    >
      {{ translateErrorPrefix + '.' + (control | firstError) | translate }}
    </small>
    <p class="fc-search-input__infix-paragraph">
      {{ displayText }}
    </p>
  </div>

  <div
    class="fc-search-input__suffix"
    [class.fc-search-input__suffix-chevron]="showChevronIcon"
    [class.fc-search-input__suffix-chevron--opened]="optionsListOpened"
    [class.fc-search-input__suffix--disabled]="control.disabled"
    *ngIf="showChevronIcon || (control.value && !control.disabled)"
    (click)="onOptionCleared()"
  >
    <mat-icon>{{ showChevronIcon ? 'arrow_drop_down' : 'cancel' }}</mat-icon>
  </div>
</div>

<div class="address-message">
  <div *ngFor="let error of googleCustomerAddressErrors" class="address-message__error">
    <mat-icon>error</mat-icon>
    <span>
      {{ error }}
    </span>
  </div>
  <div *ngFor="let warning of googleCustomerAddressWarnings" class="address-message__warning">
    <mat-icon>warning</mat-icon>
    <span>
      {{ warning }}
    </span>
  </div>
</div>

<mat-autocomplete
  #matAutocomplete="matAutocomplete"
  autoActiveFirstOption
  [displayWith]="displayWith"
  (optionSelected)="onOptionSelected($event)"
  (opened)="onAutocompleteScroll()"
  (closed)="optionsListOpened = false"
>
  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  <mat-option
    *ngFor="let option of options"
    [value]="option"
    [matTooltip]="option | map: displayWith"
    [matTooltipShowDelay]="500"
  >
    <span>{{ option | map: displayWith }}</span>
  </mat-option>
  <mat-option *ngIf="!options.length && !loading">
    {{ 'SEARCH_INPUT.NO_RESULTS' | translate }}
  </mat-option>
</mat-autocomplete>
